import * as React from "react";
import {useEffect} from "react";
import {logout, resetAuth} from "login/actions";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {logoutBranch} from "analytics/branch";
import {RouteComponentProps} from "react-router-dom";
import {clearProfile} from "profile/actions";
import {LoginMode} from "login/reducer";

interface IProps {
  auth: any;
  dispatch?: (action: any) => void;
  pathname: string;
  search: any;
  loginMode: LoginMode;
  router: any;
}

function Logout(props: IProps & RouteComponentProps) {
  const pathname = props.pathname && props.pathname !== "sl" ? `/${props.loginMode === LoginMode.V2 ? "login-v2/" : ""}${props.pathname}` : `/${props.loginMode === LoginMode.V2 ? "login-v2" : ""}`;
  useEffect(() => {
    if ((window as any).Kommunicate !== undefined) {
      (window as any).Kommunicate.logout();
    }
    logoutBranch();
    (window as any)?.webengage?.user?.logout();
    props.dispatch(logout(pathname, "", props.loginMode, props.router?.location?.state));
    props.dispatch(resetAuth());
    props.dispatch(clearProfile());
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("aggregator_details");
    const kommunicateScript = document.getElementById("kommunicate-bot");
  }, []);
  return null;
}

const mapStateToProps = (state: IReduxState): IProps => {
  return {
    auth: state.login.auth,
    pathname: state.userform.param,
    search: state.userform.search,
    loginMode: state.login.loginMode,
    router: state.router,
  };
};

export default connect<{}, {}, {}>(mapStateToProps)(Logout);
